import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=17c995cb"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=17c995cb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports